var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.500076 6C0.500076 5.72386 0.723933 5.5 1.00008 5.5H14.6667C14.9429 5.5 15.1667 5.72386 15.1667 6C15.1667 6.27614 14.9429 6.5 14.6667 6.5H1.00008C0.723933 6.5 0.500076 6.27614 0.500076 6Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.85363 0.646447C6.04889 0.841709 6.04889 1.15829 5.85363 1.35355L1.20718 6L5.85363 10.6464C6.04889 10.8417 6.04889 11.1583 5.85363 11.3536C5.65837 11.5488 5.34178 11.5488 5.14652 11.3536L0.500076 6.70711C0.109551 6.31658 0.109552 5.68342 0.500076 5.29289L5.14652 0.646447C5.34178 0.451184 5.65837 0.451184 5.85363 0.646447Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow_left.9ca65282c1ee7b0bf6cc7739bdea6a55.svg";
export { ForwardRef as ReactComponent };